import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dd91f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  class: "DialogBody",
  style: {"width":"auto","max-width":"none"}
}
const _hoisted_4 = {
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_5 = { class: "F-Bold M-Auto" }
const _hoisted_6 = {
  class: "W-100 InvoiceHeader",
  style: {"text-align":"start","grid-template-columns":"20% 80%"}
}
const _hoisted_7 = { class: "FieldName" }
const _hoisted_8 = { class: "FieldValue" }
const _hoisted_9 = {
  class: "W-100 InvoiceHeader",
  style: {"text-align":"start"}
}
const _hoisted_10 = { class: "FieldName" }
const _hoisted_11 = { class: "FieldValue" }
const _hoisted_12 = { class: "FieldName" }
const _hoisted_13 = { class: "FieldValue" }
const _hoisted_14 = { class: "FieldName" }
const _hoisted_15 = { class: "FieldValue" }
const _hoisted_16 = { class: "FieldName" }
const _hoisted_17 = { class: "FieldValue" }
const _hoisted_18 = {
  class: "DialogSection",
  id: "TableToPrint"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRow F-C2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving || _ctx.Loading.length)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            class: "PrintButton Shadow2 BGRed D-Flex RowMargin NOPRINT",
            style: {"background-color":"var(--colorr1)"}
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Translate('Close')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.Translate('Supplier') + ':'), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.DialogData?.Data.SupplierName), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.Translate('Date') + ':'), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.DateFormatter(_ctx.DialogData?.Data.AddedDate)), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.Translate('Vehicle No') + ':'), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.DialogData?.Data.VehicleNumber), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.Translate('Driver') + ':'), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.DialogData?.Data.DriverName !== 'undefined' ? _ctx.DialogData?.Data.DriverName : ''), 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.Translate('Employee') + ':'), 1),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.DialogData?.Data.EmployeeName), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_CookiesTable, {
            CookiesInvalidInput: _ctx.TransferItems.length < 1,
            ErrorData: _ctx.ErrorsVisibilty && _ctx.TransferItems.length < 1,
            class: "Shadow1",
            TableSettings: _ctx.TableSettings,
            CookiesData: _ctx.$store.state.CookiesConfig[`Branch_${_ctx.$store.state.BranchManagment.CurrentBranch?.ID}_AlwaysCombineItems`] ? _ctx.CombinedItems : _ctx.TransferItems
          }, null, 8, ["CookiesInvalidInput", "ErrorData", "TableSettings", "CookiesData"])
        ]),
        _hoisted_19,
        _hoisted_20
      ])
    ])
  ], 8, _hoisted_1))
}